import React, { useState, useRef, forwardRef, useEffect } from 'react'
import { Row, Col, Modal, Button, Form, Tabs, Tab } from 'react-bootstrap'
import { MoreVert, Delete } from '@mui/icons-material'
import Swal from 'sweetalert2'

import Table from '../../../../components/Table/DataTable'
import SurveySkeleton from './SurveySkeleton'
import httpClient, { getBaseURL } from '../../../../utility/httpClient.util'
import PreviewFile from 'components/Document/PreviewFile'
import PreviewDocxFile from 'components/Document/PreviewDocxFile'
import PrintReport from './PrintReport'
import { printData } from 'designer/component/element/table/Action'

const MENU_ID = 'category-menu'

const mockSurveyJSON = {
    layoutData: { size: "A4", orientation: 'portrait' },
    publishData: { autoPrint: false },
    printData: {},
    dataSourceData: {},
    paramsData: {},
};
const AiHelperModal = ({
    show,
    onHide,
    data = {},
    onApply = () => { }
}) => {
    const inputFileRef = useRef(null);
    const [localData, setLocalData] = useState(data)
    const [file, setFile] = useState(null);
    const [surveyJSON, setSurveyJSON] = useState(mockSurveyJSON)
    const [isLoading, setIsLoading] = useState(false)
    const [isAiSuccess, setIsAiSuccess] = useState(false)
    const [tab, setTab] = useState('survey')
    const [previewUrl, setPreviewUrl] = useState(null);
    const [attachment, setAttachment] = useState()
    const [prompt, setPrompt] = useState([])

    useEffect(() => {
        const handlePaste = (event) => {
            const items = event.clipboardData.items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.startsWith('image/')) {
                    const blob = items[i].getAsFile();
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        setPreviewUrl(e.target.result);
                    };
                    reader.readAsDataURL(blob);
                    setFile(blob)
                    onUpload(blob)
                } else {
                    setPreviewUrl(null)
                }
            }
        };

        window.addEventListener('paste', handlePaste);

        return () => {
            window.removeEventListener('paste', handlePaste);
        };
    }, []);

    const onClear = () => {
        setSurveyJSON(mockSurveyJSON)
        setIsAiSuccess(false)
        setPreviewUrl(null)
        setFile(null)
        setAttachment(null)
    }

    const onChange = async (field, value) => {
        await setLocalData({ ...localData, [field]: value })
        //onChangeSelected(field,value);
    }

    const onChooseFile = () => {
        //setIsLoading(true)
        inputFileRef.current.click();
    };
    let pollInterval;

    const pollJobProgress2 = async (attachmentSurveyId) => {
        try {
            // Poll every 2 seconds
            pollInterval = setInterval(async () => {
                const jbResponse = (await httpClient.get(`/designer/attachment-survey/${attachmentSurveyId}/job-progress`)).data;

                console.log('Polling job progress:', jbResponse.data);

                // Check if the status is 'completed'
                if (jbResponse.data.status === 'completed') {
                    console.log('Job completed');
                    setSurveyJSON(parseTextJson(jbResponse.data.jsonData))
                    setPrompt([jbResponse.data.prompt])
                    // Stop polling
                    clearInterval(pollInterval);

                    // Handle completed status, e.g., update UI, alert user, etc.
                    Swal.fire('Analysis Completed!', '', 'success');
                }
            }, 2000); // Poll every 2 seconds
        } catch (error) {
            console.error('Error polling job progress:', error);
            Swal.fire('Error!', 'Failed to fetch job progress', 'error');

            // Stop polling if there's an error
            clearInterval(pollInterval);
        }
    }

    const pollJobProgress = async (categoryAnalyzerId) => {
        return new Promise((resolve, reject) => {
            try {
                // Poll every 2 seconds
                const pollInterval = setInterval(async () => {
                    try {
                        const jbResponse = (await httpClient.get(`/designer/attachment-analyzer/${categoryAnalyzerId}/openai-job-progress`)).data;
                        console.log('Polling job progress:', jbResponse.data);

                        // Check if the status is 'completed'
                        if (jbResponse.data.status === 'completed') {
                            console.log('Job completed');

                            // Stop polling
                            clearInterval(pollInterval);

                            // Resolve the promise when job is completed
                            resolve(jbResponse);

                            // Handle completed status, e.g., update UI, alert user, etc.
                            Swal.fire('Analysis Completed!', '', 'success');
                        }
                    } catch (error) {
                        console.error('Error polling job progress:', error);

                        // Stop polling and reject the promise if there's an error
                        clearInterval(pollInterval);
                        reject(error);
                    }
                }, 5000); // Poll every 2 seconds
            } catch (error) {
                reject(error);
            }
        });
    }

    const handleAnalysis = async (attachment) => {
        try {
            const response2 = (await httpClient.post(`/designer/attachment-analyzer`, {
                attachmentId: attachment.attachmentId,
                categoryAnalyzerCode: "REPORT",
                source: "Report",
                sourceId: "" + data.reportId,
                format: "json"
            })).data
            if (response2.data.result) {
                setSurveyJSON(parseTextJson(response2.data.result[0]))
                setPrompt(prevPrompt => prevPrompt.concat(response2.data.analysisPrompt));
                Swal.fire('Analysis Completed!', '', 'success');
                setIsAiSuccess(true)
            } else if (response2.data.threadId) {
                //Poll Analysis
                const jbResponse = await pollJobProgress(response2.data.categoryAnalyzerId)
                if (jbResponse.data.result) {
                    setSurveyJSON(parseTextJson(jbResponse.data.result[0]))
                    setPrompt(prevPrompt => prevPrompt.concat(jbResponse.data.analysisPrompt));
                    setIsAiSuccess(true)
                } else {

                }
            }
        } catch (error) {
            if (error.response) {
                // Handle specific HTTP status codes here
                if (error.response.status === 422) {
                    // Handle 422 Unprocessable Entity
                    console.error('Validation error:', error.response.data);
                    Swal.fire('Validation Error!', error.response.data?.message, 'error');
                } else if (error.response.status === 500) {
                    // Handle 500 Internal Server Error
                    Swal.fire('Server Error!', 'Something went wrong on the server', 'error');
                } else {
                    // Handle other status codes
                    console.error('Error:', error.response.status);
                    Swal.fire('Error!', `Error ${error.response.status}: ${error.response.statusText}`, 'error');
                }
            } else {
                // Network error or other issue
                console.error('Network error or unknown issue:', error.message);
                Swal.fire('Network Error!', 'Please check your internet connection', 'error');
            }
        }
    }

    const parseTextJson = (surveyJSON) => {
        let jsonData = { ...mockSurveyJSON, ...surveyJSON }
        if (surveyJSON?.layoutData && typeof surveyJSON.layoutData === "string") {
            jsonData.layoutData = JSON.parse(surveyJSON.layoutData)
        }
        if (surveyJSON?.printData && typeof surveyJSON.printData === "string") {
            jsonData.printData = JSON.parse(surveyJSON.printData)
        }
        return jsonData
    }

    const onUpload = async (file) => {
        setIsLoading(true)
        setIsAiSuccess(false)
        setAttachment(null)
        const mediaGroupCode = 'DESIGNER_REPORT';
        const prompt = ""
        const formData = new FormData();
        formData.append("file", file);

        const response = (await httpClient.post(`/media/attachment/upload/${mediaGroupCode}?titleName=${file.name}`, formData)).data

        setAttachment(response.data)

        await handleAnalysis(response.data)

        setIsLoading(false)
    }



    const handelFileMaxSize = (file) => {
        const maxSizeInBytes = 5 * 1024 * 1024;
        if (file && file.size > maxSizeInBytes) {
            Swal.fire(
                "แจ้งเตือน",
                "อัพโหลดไฟล์ไม่สำเร็จขนาดไฟล์ใหญ่เกินไป ",
                "warning"
            );
        } else {
            return true;
        }
    };

    const handelUploadFIle = (e) => {
        if (e.target.files.length > 0) {
            let file = e.target.files[0];
            //   const validate = handelFileMaxSize(file);
            //   if (validate) {
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewUrl(reader.result);
                };
                reader.readAsDataURL(file);
            } else if(file.type==='application/pdf'){
                const imageURL = URL.createObjectURL(file);
                setPreviewUrl(imageURL);                
            }else{
                setPreviewUrl(null)
            }
            setFile(file);
            onUpload(file)
            //}
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const droppedImage = files[0];
            setFile(droppedImage);

            console.log('drop',droppedImage)
            const imageURL = URL.createObjectURL(droppedImage);
            setPreviewUrl(imageURL);

            e.dataTransfer.clearData();
            onUpload(droppedImage)
        }
    };

    const onAnalysisAgain = async () => {
        setIsLoading(true)
        setIsAiSuccess(false)
        await handleAnalysis(attachment)
        setIsLoading(false)
    }


    const ReportPreview = ({ surveyJSON }) => {

        return (
            <div style={{ border: '1px solid' }}>
                <PrintReport jsonData={surveyJSON} showOnlyPrintArea={true} />
                {/* {JSON.stringify(surveyJSON)} */}
            </div>
        );
    }

    const fileUrl = attachment ? `${getBaseURL()}/media/attachment/originalFile/${attachment.attachmentId}` : null

    return (
        <Modal centered show={show} onHide={onHide} size="xl" dialogClassName='modal-100w'>
            <Modal.Header closeButton>
                <Modal.Title as="h5"><i className="fas fa-robot mr-1" />AI Helper</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}>


                    <Row style={{ display: 'none' }}>
                        <Col sm="6" className="my-auto mb-2 p-0 ml-3">
                            <i className="fas fa-chat" /> Prompt Text
                        </Col>
                        <Col sm="12" className="mb-2">
                            <Form.Control
                                as="textarea"
                                rows={3}
                                onChange={(e) => onChange('promptText', e.target.value)}
                                value={localData?.promptText}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center mb-2">

                            <Form.Control
                                style={{ display: "none" }}
                                ref={inputFileRef}
                                onChange={(e) => handelUploadFIle(e)}
                                type="file"
                            />
                            <Button
                                className="mb-2 mr-2"
                                variant="light"
                                style={{ border: "1px solid #b5b5b5" }}
                                onClick={onChooseFile}
                                disabled={isLoading}
                            >
                                <i className='fas fa-hand-point-down' />  {isLoading ? 'Loading...' : 'Click Upload file to analysis '}{" "}
                            </Button>
                            {attachment && !isLoading && (<Button onClick={onAnalysisAgain} disabled={isLoading}> <i className='fas fa-redo' /> Analysis Again </Button>)}
                            {file ? file.name : ''}
                        </Col>
                    </Row>
                    {isAiSuccess && (
                        <Row>
                            <Col className="d-flex justify-content-center mb-2">
                                <Button variant="outline-primary" className='m-r-10' onClick={() => onApply(surveyJSON)}>
                                    <i className="fa fa-bolt" /> Apply this report
                                </Button>
                                <Button variant="outline-primary" className='m-r-10' onClick={() => onClear()}>
                                    <i className="fa fa-trash" /> Clear File
                                </Button>
                            </Col>
                        </Row>)}
                    <Row
                        className="m-auto w-100 pt-2 px-2"
                    >
                        <Col
                            md={6}
                        >
                            {isLoading ?
                                (<Row>
                                    <Col md={12}>
                                        <SurveySkeleton isLoading />
                                    </Col>
                                </Row>)
                                : (<Row>
                                    <Col md={12}>
                                        <h4>AI Output Preview:</h4>
                                        <ReportPreview surveyJSON={surveyJSON} />
                                    </Col>
                                </Row>)}
                        </Col>
                        <Col
                            md={6}
                        >

                            <div>
                                <h4>Input Preview:</h4>
                                {file && file.type.startsWith('image/') && previewUrl && (<img src={previewUrl} alt="Selected" style={{ width: '100%', height: 'auto', marginTop: '10px' }} />)}
                                {file && file.type==='application/pdf' && (
                                    <PreviewFile fileUrl={previewUrl} />
                                )}
                                {/* {attachment?.fileExtension === 'pdf' && (
                                    <PreviewFile fileUrl={fileUrl} />
                                )} */}
                                {attachment?.fileExtension === 'docx' && (
                                    <PreviewDocxFile fileUrl={fileUrl} />
                                )}
                            </div>

                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AiHelperModal
